export interface InvestorView {
  name: string | null
  firmName: string | null
  verified: boolean
}

/**
 * The investor's name and firm, only when the account check has passed and the name is there. Anything
 * else is shown as "entered by the investor", so an unverified name is never presented as confirmed.
 */
export function verifiedIdentity(
  investor: InvestorView
): { name: string; firm: string | null } | null {
  if (!investor.verified || !investor.name) return null
  return { name: investor.name, firm: investor.firmName || null }
}

/** The address with the token replaced, so analytics page views never carry an invite token. */
export function redactInvitePath(pathname: string): string {
  return pathname.replace(/^\/i\/[^/]+/, '/i/:token')
}
